import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import SolutionsEnterpriseContainer from '~/features/solutions/enterprise'
import en_solutions from '../../../public/locales/en/solutions.json'
import jp_solutions from '../../../public/locales/ja/solutions.json'

const SolutionsEnterprisePage: FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <HeadMetaTags
        title={t('meta:solutions_enterprise:meta_title')}
        description={t('meta:solutions_enterprise:meta_description')}
      />
      <SolutionsEnterpriseContainer />
    </>
  )
}

export default withTranslateProvider(SolutionsEnterprisePage, {
  en: { solutions: en_solutions },
  ja: { solutions: jp_solutions }
})
